(() => {
  const synchronize = () => {
    const offers = window._VL?.offers;
    if (!Array.isArray(offers)) return;
    document.querySelectorAll('[data-kirova-bulk-card-price]:not([data-explicit-price])').forEach((box) => {
      const base = Number(box.dataset.basePrice);
      const relevant = offers.filter((offer) => offer.extension_type === 'wholesale'
        && offer.trigger_type === 'products' && !offer.trigger_customer_tags?.length
        && (!offer.ends_at || new Date(offer.ends_at).getTime() > Date.now())
        && (!offer.starts_at || new Date(offer.starts_at).getTime() <= Date.now())
        && offer.trigger_data_products?.some((product) => String(product.id) === box.dataset.productId));
      if (!base || !relevant.length) return;
      const prices = relevant.flatMap((offer) => (offer.wholesale_tier_settings || []).map((tier) => {
        if (offer.discount_type === 'percentage') {
          const discount = Math.max(0, Math.min(100, Number(tier.discount_value_percentage) || 0));
          return base - Math.floor(base * discount / 100 + 1e-8);
        }
        if (offer.discount_type === 'fixed') return Math.max(0, base - Math.round((Number(tier.discount_value_fixed) || 0) * 100));
        return base;
      }));
      if (!prices.length) return;
      const price = Math.min(...prices);
      // The shop sells in EUR. Leave Shopify's formatted fallback in other markets.
      if (window.Shopify?.currency?.active && window.Shopify.currency.active !== 'EUR') return;
      const amount = (price / 100).toLocaleString(document.documentElement.lang || 'bg', {minimumFractionDigits: 2, maximumFractionDigits: 2});
      box.querySelector('.price-item').textContent = `От ${amount} €`;
    });
  };
  synchronize();
  document.addEventListener('kirova:products-updated', synchronize);
  document.addEventListener('shopify:section:load', synchronize);
  window.addEventListener('load', synchronize, {once: true});
})();
